import React from 'react'
import { Table } from 'antd'
import { formatMoney } from '../../../utils/number-utils'
import { comparePrice, getCellOverStyle } from '../web-search-utils'

const numberCellStyle = {
  padding: 8,
  height: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  overflowWrap: 'normal',
}

const urlCellStyle = {
  wordWrap: 'break-word',
  wordBreak: 'break-all', // или 'break-word'
  overflowWrap: 'break-word',
  whiteSpace: 'pre-wrap',
  maxWidth: '100%',
}

const WebSearchResultTable = ({ results, estimatePrice }) => {
  const columns = [
    {
      title: 'Имя продукта',
      dataIndex: 'product_name',
      key: 'product_name',
    },
    {
      title: 'Источник',
      dataIndex: 'source',
      key: 'source',
    },
    {
      title: () => <div style={{ padding: 8 }}>Цена</div>,
      dataIndex: 'price',
      key: 'price',
      className: 'no-padding-cell-report',
      align: 'right',
      width: 200,
      render: (price) => {
        const over = comparePrice(estimatePrice, price)
        return <div style={{ ...numberCellStyle, ...getCellOverStyle(over) }}>{formatMoney(price)}</div>
      },
    },
    {
      title: 'Дата актуальности',
      dataIndex: 'actual_date',
      key: 'actual_date',
    },
    {
      title: 'Ссылка для покупки',
      dataIndex: 'url',
      key: 'url',
      width: 1000,
      render: (text) => (
        <div style={{ ...urlCellStyle }}>
          <a href={text} target="_blank" rel="noreferrer">
            {text}
          </a>
        </div>
      ),
    },
    {
      title: 'В наличие',
      dataIndex: 'in_stock',
      key: 'in_stock',
    },
  ]

  return <Table pagination={false} style={{ paddingTop: 20 }} columns={columns} dataSource={results} bordered />
}

export default WebSearchResultTable
